// Push.js

import React, {Component} from 'react';
import { Button, Form } from 'react-bootstrap';
import Config from '../Config';

export default class Push extends Component {
    constructor(props) {
    super(props);
    this.state = {
        value: '제목을 입력하세요.',
        to: '',
        icon: 'icons/favicon.png',
        pcodeurl: '',
        content : '내용을 입력하세요.',
        country : 'KR',
        lang : 'Kor',
        sendcount : 0
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.handleChangeIcon = this.handleChangeIcon.bind(this);
    this.handleChangePCodeUrl = this.handleChangePCodeUrl.bind(this);
    this.handleChangeContent = this.handleChangeContent.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeLang = this.handleChangeLang.bind(this);
    this.handleChangeCountry = this.handleChangeCountry.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
    }

    handleChangeTo(event) {
        this.setState({to: event.target.value});
    }

    handleChangeIcon(event) {
        this.setState({icon: event.target.value});
    }

    handleChangePCodeUrl(event) {
        this.setState({pcodeurl: event.target.value});
    }

    handleChangeContent(event) {
        this.setState({content: event.target.value});
    }

    handleChangeLang(event) {
        this.setState({lang: event.target.value});
    }

    handleChangeCountry(event) {
        this.setState({country: event.target.value});
    }

    fetchData(address, params, callback, revalidate = false, cbError) {

        var chcheoption = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (revalidate) {
            // chcheoption['Cache-Control'] = 'must-revalidate';
        }

        fetch(`${Config.Server}/${address}`, {
            // mode: 'no-cors',
            method: 'POST',
            headers: chcheoption,
            body: JSON.stringify(params)
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (callback)
                    callback(responseJson.result, responseJson.count);
            })
            .catch((error) => {
                console.error(error);
                cbError(error);
            });
    }
    
    handleSubmit(event) {

            this.fetchData('pushall' , {
                COUNTRY_CODE: this.state.country,
                LANGUAGE_CODE: this.state.lang,
                TITLE: this.state.value,
                TO: this.state.to,
                ICON: this.state.icon,
                PCODEURL: this.state.pcodeurl,
                CONTENT: this.state.content
            }, (result, count) => {
                console.log('pushall=', count);
                this.setState({sendcount : count})
            }, true);    

            event.preventDefault();
    }

    render(){
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <h3 className="box-title">푸시알림 보내기</h3>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    <div className="row">
                                        {/* <form onSubmit={this.handleSubmit}>
                                            <div className="col-md-8">
                                                <label>
                                                    제목:<br/>
                                                    <input type="text" value={this.state.value} onChange={this.handleChange} />
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <label>
                                                내용:<br/>
                                                <textarea value={this.state.content} onChange={this.handleChangeContent} />
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                            <label>
                                                언어코드: ko,en,ja,zh<br/>
                                                <input type="text" value={this.state.lang} onChange={this.handleChangeLang} />
                                            </label>
                                            </div>
                                            <div className="col-md-8">
                                            <label>
                                                국가코드: KR<br/>
                                                <input type="text" value={this.state.country} onChange={this.handleChangeCountry} />
                                            </label>
                                            </div>
                                            <div className="col-md-8">
                                                <Button variant="primary" onClick={this.handleSubmit}>전송</Button>
                                            </div>
                                        </form> */}
                                        <Form>
                                            <Form.Group controlId="exampleForm.ControlInput1">
                                                <Form.Label>제목</Form.Label>
                                                <Form.Control type="title" placeholder="제목을 입력하세요." value={this.state.value} onChange={this.handleChange} />
                                            </Form.Group>
                                            <Form.Group controlId="exampleForm.ControlSelect1">
                                                <Form.Label>언어선택</Form.Label>
                                                <Form.Control as="select" value={this.state.lang} onChange={this.handleChangeLang}>
                                                <option>Kor</option>
                                                <option>Eng</option>
                                                <option>Jpn</option>
                                                <option>Chn</option>
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group controlId="exampleForm.ControlInput1">
                                                <Form.Label>수신자</Form.Label>
                                                <Form.Control type="title" placeholder="이메일 주소를 입력[전체는 빈칸 여러명은 , 로 구분]" value={this.state.to} onChange={this.handleChangeTo} />
                                            </Form.Group>
                                            <Form.Group controlId="exampleForm.ControlInput1">
                                                <Form.Label>아이콘</Form.Label>
                                                <Form.Control type="title" placeholder="" value={this.state.icon} onChange={this.handleChangeIcon} />
                                            </Form.Group>
                                            <Form.Group controlId="exampleForm.ControlInput1">
                                                <Form.Label>PCODE 또는 URL</Form.Label>
                                                <Form.Control type="title" placeholder="상품코드 또는 URL" value={this.state.pcodeurl} onChange={this.handleChangePCodeUrl} />
                                            </Form.Group>                                            
                                            <Form.Group controlId="exampleForm.ControlTextarea1">
                                                <Form.Label>내용</Form.Label>
                                                <Form.Control as="textarea" rows="10" value={this.state.content} onChange={this.handleChangeContent}  />
                                            </Form.Group>
                                            <Button variant="primary" onClick={this.handleSubmit}>전송</Button>
                                        </Form>
                    
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                {/* <span className="description-percentage text-green"><i className="fa fa-caret-up"></i> 17%</span> */}
                                                <h5 className="description-header">Sending TOTAL: {this.state.sendcount}</h5>
                                            </div>
                                        </div>    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/Push.js